import { ComponentSearchDialogState } from ".";

export const ComponentSearchDialogInitialState: ComponentSearchDialogState = {
  componentList: [],
  isShow: false,
  isSaved: true,
};
